import { mergeAttributes, Node } from "@tiptap/core";
import { findWrapping } from "@tiptap/pm/transform";

const CALLOUT_TYPES = ["success", "warning", "error", "primary"];

// listItem musi zaczynac sie od paragrafu, wiec callout nie moze owinac tekstu wewnatrz <li>.
// Szukamy zakresu ponad listami: zaznaczenie w liscie owija cala liste.
const LIST_NODES = [
	"listItem",
	"taskItem",
	"bulletList",
	"orderedList",
	"taskList",
];

const CalloutExtension = Node.create({
	name: "callout",

	group: "block",
	content: "block+",

	defining: true,

	addAttributes() {
		return {
			type: {
				default: "primary",
				parseHTML: (element) =>
					element.getAttribute("data-callout-type") || "primary",
				renderHTML: (attributes) => ({
					"data-callout-type": attributes.type,
				}),
			},
		};
	},

	parseHTML() {
		return [{ tag: "div[data-callout-type]" }];
	},

	renderHTML({ HTMLAttributes }) {
		return [
			"div",
			mergeAttributes(HTMLAttributes, {
				class: `tiptap-callout tiptap-callout--${HTMLAttributes["data-callout-type"] || "primary"}`,
			}),
			0,
		];
	},

	addCommands() {
		return {
			setCallout:
				(type = "primary") =>
				({ state, tr, dispatch }) => {
					const { $from, $to } = state.selection;
					const range = $from.blockRange(
						$to,
						(node) => !LIST_NODES.includes(node.type.name),
					);
					const wrapping = range && findWrapping(range, this.type, { type });
					if (!wrapping) {
						return false;
					}
					if (dispatch) {
						tr.wrap(range, wrapping).scrollIntoView();
					}
					return true;
				},
			toggleCallout:
				(type = "primary") =>
				({ commands, editor }) => {
					if (editor.isActive(this.name, { type })) {
						return commands.lift(this.name);
					}
					return commands.setCallout(type);
				},
		};
	},
});

export { CALLOUT_TYPES };
export default CalloutExtension;
